import { MatchingProperty } from '../models/matching-property';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { AppAuthHttpService } from '../../http/app.auth.http.service';
import { ResponseUtilService } from '../../shared/utils/response-util.service';
import { Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { MatchingPropertyAssign } from '../models/matching-property-assign';
import { PropertyMatch } from '../models/property-match';
import { EventMatchLog } from '../models/event-match-log';

@Injectable()
export class EventMatchLogHttpService {
  private aggregateBaseURL =  '/api/event-matches';
  private eventMatchLogSearchURL: string = this.environment.baseUrl + this.aggregateBaseURL + '/search';
  private eventMatchLogReportExcelUrl: string = this.environment.baseUrl + this.aggregateBaseURL + '/report/excel ';

  constructor(private http: AppAuthHttpService,
              private environment: EnvironmentConfiguration,
              private responseUtilService: ResponseUtilService) {
  }

  private get fileOptions(): RequestOptions {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({
      headers: headers,
      responseType: ResponseContentType.Blob
    });
    return options;
  }

  getEventMatchLog(page: number, size: number, sort: string): Observable<any> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers }); // Create a request option
    return this.http.get(`${this.eventMatchLogSearchURL}?page=${page}&size=${size}&${sort}`, options)
      .map(response => response.json())
      .catch(response => this.responseUtilService.handleError(response))
      .share();
  }

  exportEventMatchLogExcel(): Observable<any> {
    return this.http.post(this.eventMatchLogReportExcelUrl, null, this.fileOptions)
      .map(res => new Blob([res.blob()], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }))
      .catch(response => this.responseUtilService.handleError(response));
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/service/event-match-log.http.service.ts